import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { NumberInput } from '../../../components/admin/number-input';
import { MoonstarCreate } from '../../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../../Moonstar/MoonstarCreateForm';
import { NudgeSlideInputs, type NudgeSlideTab } from './NudgeSlideInputs';

export const NudgeSlideCreate = () => {
  const { nudgeId } = useParams();
  const [selectedTab, setSelectedTab] = useState<NudgeSlideTab>(
    'withContentAndImage'
  );

  return (
    <MoonstarCreate redirect={() => `nudges/${nudgeId}/slides`}>
      <MoonstarCreateForm className="max-w-none">
        <NumberInput
          source="nudgeId"
          defaultValue={parseInt(nudgeId ?? '')}
          className="hidden"
        />
        <NudgeSlideInputs
          selectedTab={selectedTab}
          onTabChange={setSelectedTab}
        />
      </MoonstarCreateForm>
    </MoonstarCreate>
  );
};
